import { Col, Form, Table } from "react-bootstrap";
import { JConfirmDelete, JRow, MensagemModal } from "../../../../components/Components";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InfUnidCargaInterface, LacUnidCargaInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import { useRef, useState } from "react";
import { getUuidV4, goToFocus } from "../../../../utils/utils";
import { Link } from "react-router-dom";

const initialSelectLacre: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

interface formProps {
    form: InfUnidCargaInterface;
    setForm: React.Dispatch<React.SetStateAction<InfUnidCargaInterface>>;
}

const CTesUnidadeTranspInfLacreCargaInfUnidadeCargaLacres: React.FC<formProps> = ({ form, setForm }) => {
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelectLacre);
    const [numeroLacre, setNumeroLacre] = useState<string>('');
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const numeroLacreRef = useRef<HTMLInputElement>(null)

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelectLacre);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const validaPreenchimento = () => {
        if (numeroLacre.trim() === "") {
            alerta('Informe o número do lacre.');
            goToFocus(numeroLacreRef)
            return false;
        }

        if (form.lacUnidCarga?.find((item: LacUnidCargaInterface) => item.nLacre.toString() === numeroLacre.trim())) {
            alerta('Lacre já adicionado.');
            return false;
        }

        return true;
    }

    const handleAddLacre = () => {
        if (validaPreenchimento()) {

            form.lacUnidCarga?.push({
                id: getUuidV4(),
                nLacre: numeroLacre
            });
            setNumeroLacre('');
            goToFocus(numeroLacreRef)
        }
    }

    const handleRemoverLacre = (id: number | string) => {
        if (form.lacUnidCarga?.find(item => item.id.toString() === id.toString())) {
            setForm({ ...form, lacUnidCarga: [...form.lacUnidCarga.filter(i => i.id.toString() !== id.toString())] })
        }
        setShowModal(false);
    }

    return (<div className="ps-2">
        <JRow className="mb-3 ">
            <Col md>
                <Form.Group>
                    <Form.Label>Número do lacre</Form.Label>
                    <Form.Control type="text" value={numeroLacre}
                        ref={numeroLacreRef}
                        placeholder="Digite o número + [Enter] para adicionar"
                        onChange={(e) => setNumeroLacre(e.target.value)}
                        onKeyUp={(e) => {
                            if (e.key === 'Enter') {
                                handleAddLacre();
                            }
                        }}
                    />
                </Form.Group>
            </Col>


            <Table striped bordered hover size="sm" responsive>
                <thead className="table-light">
                    <tr>
                        <th className="text-center" style={{ width: '4.5rem' }}>#</th>
                        <th>Número do lacre</th>
                    </tr>
                </thead>
                <tbody>
                    {form?.lacUnidCarga?.map((item: LacUnidCargaInterface) => {
                        return (
                            <tr key={item?.id}>
                                <td className="text-center">
                                    <Link to={''} className="text-danger">
                                        <FontAwesomeIcon icon={faTrash} onClick={() =>
                                            item?.id && handleOpenModal(
                                                {
                                                    id: item.id,
                                                    title: item?.nLacre
                                                }
                                            )} />
                                    </Link>
                                </td>
                                <td>
                                    {item.nLacre}
                                </td>
                            </tr>
                        )
                    })
                    }

                </tbody>
            </Table>
        </JRow>
        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemoverLacre}
            selectedObject={selected.title}
            id={selected.id}
        />
    </div>)
}

export default CTesUnidadeTranspInfLacreCargaInfUnidadeCargaLacres;